/**
 * @description To retrieve the Node API Url for a given environment
 *
 * @param mode string representing environment
 * @returns apiUrl for given environment
 */

export const getApiUrl = (mode?: string) => {
  let apiUrl = 'https://app.odynn.info:3000';

  switch (mode) {
    case 'uat':
      apiUrl = 'https://appuat.odynn.info:3000';
      break;
    case 'production':
      apiUrl = 'https://app.odynn.info:3000';
      break;
    case 'development':
      apiUrl = 'https://appdev.odynn.info:3000';
      break;
    case 'local':
      apiUrl = 'http://localhost:3000';
      break;
    default:
      apiUrl = 'https://app.odynn.info:3000';
      break;
  }

  return apiUrl;
};
